
import { locationDataType } from "../reducers/locationDataReducer";
import store from "../store";



export function resetLocationData(newFilters: locationDataType){
    store.dispatch({
        type: "resetLocationData",
        payload: {
            ...newFilters
        }
    })
}

export function clearLocationData(){
    store.dispatch({
        type: "clearLocationData",
        payload: {}
    })
}